import React from 'react';
import { Field, FormSection } from 'redux-form/immutable';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import Entrepreneur from '../sections/entrepreneur';
import CountrySelector from '../sections/country-selector';
import { Api } from '../api';
import {
  SimpleInput,
  Textarea,
  Checkbox,
  MaskedInput,
  RadioButton,
  FileInput,
  makeSelectInput,
} from '../field-components';
import { required, validateYear, validateEmail } from '../validators';
import messages from '../messages';
import { connect } from 'react-redux';
import { toast } from 'react-toast';
import { createStructuredSelector } from 'reselect';
import makeSelectData from '../selectors';
import { errorTypes } from '../utils';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.StatusSelectInput = makeSelectInput(Api.fetchStatus);
  }

  onSubmit = () => {
    const { formName, appState } = this.props;

    console.log(appState.consulates_application_form.syncErrors);
    if (appState.consulates_application_form.syncErrors) {
      const requiredErrors = appState.consulates_application_form.syncErrors[formName];
      const errors = Object.keys(requiredErrors).filter((error) => requiredErrors[error] !== undefined);
      if (errors.length !== 0) {
        errors.forEach((err) => {
          toast(
            <FormattedMessage
              {...messages.needed_field}
              values={{
                attribute: (
                  <strong>
                    <FormattedMessage {...messages[errorTypes[err] || err]} />
                  </strong>
                ),
              }}
            />,
            { backgroundColor: '#cb3837', color: '#a94442' }
          );
        });
      }
    }
  };

  render() {
    const { handleSubmit, fileGuid, formName, fileFieldName, handleCountryChange, normalForm = true } = this.props;
    return (
      <div className="send-appeal-form">
        <form className="card-block clearfix" onSubmit={handleSubmit}>
          <div className="col-md-6">
            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.surname} />
              </label>
              <Field name={`${formName}[last_name]`} validate={[required]} component={SimpleInput} type="text" />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ marginTop: 5 }}>
                <FormattedMessage {...messages.name} />
              </label>
              <Field name={`${formName}[first_name]`} validate={[required]} component={SimpleInput} type="text" />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ lineHeight: 'inherit', marginTop: 10 }}>
                <FormattedMessage {...messages.secondName} />
              </label>
              <Field name={`${formName}[middle_name]`} component={SimpleInput} type="text" />
            </div>

            <FormSection>
              <CountrySelector formName={formName} handleCountryChange={handleCountryChange} />
            </FormSection>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.address} />
              </label>
              <Field
                name={`${formName}[current_address]`}
                type="text"
                component={SimpleInput}
                validate={[required]}
                className="form-control"
              />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.gender} />
              </label>
              <Field
                labelStyle={{ marginRight: '20px', marginLeft: '20px', lineHeight: 'inherit' }}
                name={`${formName}[gender]`}
                validate={[required]}
                component={RadioButton}
                inputValue="m"
                label={<FormattedMessage {...messages.man} />}
              />
              <Field
                labelStyle={{ marginRight: '20px', marginLeft: '20px', lineHeight: 'inherit' }}
                name={`${formName}[gender]`}
                validate={[required]}
                component={RadioButton}
                inputValue="f"
                label={<FormattedMessage {...messages.woman} />}
              />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.birthdate} />
              </label>
              <Field
                name={`${formName}[birthday]`}
                type="text"
                component={MaskedInput}
                mask="11.11.1111"
                placeholder="dd.mm.yyyy"
                validate={[required, validateYear]}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ lineHeight: 'inherit', marginTop: 15 }}>
                <FormattedMessage {...messages.email} />
              </label>
              <Field
                name={`${formName}[email]`}
                type="email"
                component={SimpleInput}
                validate={[validateEmail]}
                placeholder="example@mail.com"
                className="form-control"
              />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3">
                <FormattedMessage {...messages.status} />
              </label>
              <Field name={`${formName}[employment_id]`} validate={[required]} component={this.StatusSelectInput} />
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ lineHeight: '20px' }}>
                <FormattedMessage {...messages.isSecret} />
              </label>
              <Field
                labelStyle={{ marginRight: '20px', marginLeft: '20px', lineHeight: 'inherit' }}
                name={`${formName}[is_public]`}
                validate={[required]}
                component={RadioButton}
                inputValue={1}
                label={<FormattedMessage {...messages.yes} />}
              />
              <Field
                labelStyle={{ marginRight: '20px', marginLeft: '20px', lineHeight: 'inherit' }}
                name={`${formName}[is_public]`}
                validate={[required]}
                component={RadioButton}
                inputValue={0}
                label={<FormattedMessage {...messages.no} />}
              />
              <div className="col-md-9 text-justify" style={{ marginTop: '20px', paddingLeft: 25 }}>
                <p className="note">
                  <FormattedMessage {...messages.secretInfo} />
                </p>
              </div>
            </div>

            <FormSection>
              <Entrepreneur formName={formName} normalForm={normalForm} />
            </FormSection>

            <div className="item attachment-wrap clearfix">
              <div className="col-md-2" />
              <div className="col-md-10">
                <Field
                  name={`${formName}[user_file]`}
                  component={FileInput}
                  fileGuid={fileGuid}
                  fileFieldName={fileFieldName}
                  type="hidden"
                />
              </div>
            </div>
          </div>

          <div className="form-bottom col-md-12">
            <div className="item aggrement-checkbox-wrap clearfix"></div>
            <div className="mgb-15 clearfix">
              <label className="">
                <FormattedMessage {...messages.applicationLabel} />
              </label>
              <Field name={`${formName}[description]`} component={Textarea} validate={[required]} />
              {/* <p className="note"><FormattedMessage {...messages.applicationHint} /></p> */}
            </div>

            <div className="row clearfix">
              {/* <Field name="captcha" component={CaptchaField} validate={[required]}/> */}

              <Field
                name={`${formName}[is_agree]`}
                className="col-md-9"
                component={Checkbox}
                onChange={(e) => {
                  let elem = document.getElementById(`${formName}-offerModal-trigger`);
                  e.target.checked && elem && elem.click();
                }}
                id={`${formName}-checkbox-aggrement`}
                validate={[required]}
                label={
                  <FormattedHTMLMessage
                    {...messages.agreementHint}
                    values={{
                      link: '#',
                      id: `${formName}-offerModal-trigger`,
                      dataToggle: 'modal',
                      dataTarget: '#offerModal',
                    }}
                  />
                }
                labelStyle={{
                  marginBottom: 20,
                }}
                type="checkbox"
              />

              <div className="col-md-3" style={{ marginTop: '5px' }}>
                <button className="btn submit_btn pull-right" onClick={this.onSubmit}>
                  <FormattedMessage {...messages.sendButton} />
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({ appState: makeSelectData() });

export default connect(mapStateToProps)(Form);



// WEBPACK FOOTER //
// ./src/application-form/forms/abroad.js